import React from 'react';
import { VStack, Text, Button } from '@chakra-ui/react';
import { useMerchantGroup } from '@domain/merchants/queries/useMerchantGroup';
import { useCreateMerchantTheme } from '@domain/merchants/mutations/useCreateMerchantTheme';
import { useError } from '@olo-web/utils/common/hooks';
import { useToast } from '@olo-web/utils/common/hooks';

export const CreateTheme = () => {
  const { data: group } = useMerchantGroup();
  const { notify } = useToast();
  const callError = useError();
  const { mutate, isLoading } = useCreateMerchantTheme({
    onSuccess: () => {
      notify({
        status: 'success',
        title: 'Theme created!',
        description: 'Time to make this site your own!',
        variant: 'left-accent',
        position: 'bottom-left',
      });
    },
    onError: (error) => callError({ error, toastError: true }),
  });

  const handleClick = () => {
    if (!group?.merchants?.length) {
      notify({
        status: 'error',
        title: 'Merchant group not loaded',
        variant: 'left-accent',
        position: 'bottom-left',
      });
    }
    if (group) {
      mutate(group.merchants.map((m) => m.merchantId));
    }
  };

  return (
    <VStack spacing={8}>
      <Text textAlign="center">Create a theme for this merchant location.</Text>
      <Button size="lg" colorScheme="primary" onClick={handleClick} isLoading={isLoading}>
        Create a theme
      </Button>
    </VStack>
  );
};
